module.exports = __webpack_public_path__ + "25ed5e3bb1bef8ef7e4f14271cf7a7c0.svg";